export function isProduction() {
  return window.location.hostname.match('(www.)?checkers.online$')
}
